import { Component } from "react";
import "./AzureCitySelect.css";
import AzureMapsService from "../../../../../services/azuremaps";
import { t } from "../../../../../translations/translation.service";

export type CityOption = {
  label: string;
  value: string;
  city: string;
  state: string;
  country: string;
  position?: {
    lat: number;
    lon: number;
  };
};

type Props = {
  placeholder: string;
  value?: { label?: string } | null;
  onChange: (city: CityOption) => void;
  noBorder?: boolean;
  currentLanguage: string;
};

type State = {
  inputValue: string;
  options: CityOption[];
  loading: boolean;
  isOpen: boolean;
  unavailable: boolean;
};

class AzureCitySelect extends Component<Props, State> {
  state: State = {
    inputValue: this.props.value?.label || "",
    options: [],
    loading: false,
    isOpen: false,
    unavailable: false
  };

  componentDidUpdate(prevProps: Props) {
    if (prevProps.value?.label !== this.props.value?.label) {
      this.setState({
        inputValue: this.props.value?.label || ""
      });
    }
  }

  buscarCidades = async (term: string) => {
    if (term.length < 3) {
      this.setState({ options: [], loading: false, unavailable: false });
      return;
    }

    try {
      this.setState({ loading: true, unavailable: false });

      const response = await AzureMapsService.buscarCidade(term, this.props.currentLanguage);

      const mapped: CityOption[] = (response.data || []).map((item: any) => ({
        label: item.label,
        value: item.label,
        city: item.city,
        state: item.state,
        country: item.country,
        position: item.position
      }));

      this.setState({ options: mapped });
    } catch (e) {
      console.error("Erro ao buscar cidades:", e);
      this.setState({ options: [], unavailable: true });
    } finally {
      this.setState({ loading: false });
    }
  };

  handleInputChange = (value: string) => {
    this.setState({
      inputValue: value,
      isOpen: true
    });

    this.buscarCidades(value);
  };

  handleSelect = (option: CityOption) => {
    this.setState({
      inputValue: option.label,
      options: [],
      isOpen: false,
      unavailable: false
    });

    this.props.onChange(option);
  };

  renderMenu() {
    const { inputValue, options, loading, unavailable } = this.state;

    if (loading) {
      return (
        <ul className="azure-city-select__menu">
          <li className="azure-city-select__loading-row">
            <span className="azure-city-select__spinner" />
            {t("Buscando cidades...")}
          </li>
        </ul>
      );
    }

    if (unavailable) {
      return (
        <ul className="azure-city-select__menu">
          <li className="azure-city-select__item azure-city-select__item--disabled">
            {t("Busca de cidades indisponível no momento")}
          </li>
        </ul>
      );
    }

    if (options.length > 0) {
      return (
        <ul className="azure-city-select__menu">
            {options.map(option => (
            <li key={option.value} className="azure-city-select__item">
             <button
               type="button"
               className="azure-city-select__button"
               onClick={() => this.handleSelect(option)}
             >
               {option.label}
             </button>
            </li>
         ))}
        </ul>
      );
    }

    if (inputValue.length < 3) {
      return (
        <ul className="azure-city-select__menu">
          <li className="azure-city-select__item azure-city-select__item--disabled">
            {t("Digite ao menos 3 letras")}
          </li>
        </ul>
      );
    }

    return (
      <ul className="azure-city-select__menu">
        <li className="azure-city-select__item azure-city-select__item--disabled">
          {t("Nenhuma cidade encontrada")}
        </li>
      </ul>
    );
  }

  render() {
    const { inputValue, isOpen } = this.state;
    const { placeholder } = this.props;

    return (
      <div className="azure-city-select">
        <input
          className={`azure-city-select__input${this.props.noBorder ? ' no-border-input' : ''}`}
          type="text"
          placeholder={placeholder}
          value={inputValue}
          onFocus={() => this.setState({ isOpen: true })}
          onChange={e => this.handleInputChange(e.target.value)}
        />

        {isOpen && this.renderMenu()}
      </div>
    );
  }
}

export default AzureCitySelect;
